import {$, T} from "../../common/drupal/drupal";

class Cocktails {

    /**
     * Initialize event listeners
     */
    init () {
        // MORE BUTTON
        let step = 6;
        $('.NodeCocktailList-list-cocktails').each(function() {
            let moreButton = $('<button type="button" class="btn">' + Drupal.t('Voir plus') + '</button>');
            let nbCocktails = $(this).find('.NodeListElement').length;
            if (nbCocktails > step) {
                // hide items if more than 6
                $(this).find('.NodeListElement:gt('+ (step - 1) +')').addClass('item-hidden');
                // append more button
                $('<div class="more-container"></div>').append(moreButton).appendTo(this);
                // click function
                moreButton.on('click', function() {
                    $(this).closest('.NodeCocktailList-list-cocktails').find('.item-hidden').slice(0,step).removeClass('item-hidden');
                    if ($(this).closest('.NodeCocktailList-list-cocktails').find('.item-hidden').length == 0) {
                      $(this).parent().hide();
                    }
                });
            };
        });
    }

    attach(context) {
        this.init(context);
    }
}

export let cocktails = new Cocktails();
